
export default {
    name: 'receipts',
    data: () => ({
        receipt: {
            emailed_receipt: '',
            printed_receipt: '',
            header: '',
            footer: '',
            show_customer_info: false,
            show_comments: false,
            receipt_language: 'en'
        },
        noAllStores: true
    }),
    methods: {
        async getReceipt() {
            const res = this.$communicator.then(
                this, await this.$communicator('get_settings_receipt', {
                    params: {
                        service: this.store
                    }
                })
            )
            if (res) {
                this.receipt = this.$copy(res)
                this.alert = true
            }
            else {
                this.receipt = {
                    emailed_receipt: '',
                    printed_receipt: '',
                    header: '',
                    footer: '',
                    show_customer_info: false,
                    show_comments: false,
                    receipt_language: 'en'
                }
            }
        },
        async updateReceipt() {
            this.update_loading = true
            this.receipt.service = this.store
            this.$communicator.then(
                this, await this.$communicator('save_settings_receipt', {
                    params: this.receipt
                })
            )
            this.$toast.success("Success", {timeout: 2000});
            this.update_loading = false
            this.getReceipt()
        }
    }
}
